import './Onboarding.scss'
import { Box, Button, CircularProgress, Grid2, Typography } from '@mui/material'
import PaperItem from '../Essential/PaperItem'
import { useTranslation, Trans } from 'react-i18next'
import ProjectAdminModel from '../../pages/projects/admin/ProjectAdminModel'
import ProjectAdminController from '../../pages/projects/admin/ProjectAdminController'
import { generateUuid } from '../../utils/Utils'
import * as React from 'react'

export const Onboarding = ({ data, onClick }) => {
  const { t } = useTranslation()

  const model = ProjectAdminModel()
  const controller = ProjectAdminController(model)

  return (
    <Grid2 container spacing={2} className='projectAdmin'>
      <PaperItem className='flex-col gap-2 boxShadow' sx={{ width: '100%', p: 10 }} >
        <Grid2 container spacing={10} className='projectAdmin' flexDirection='row' justifyContent='space-evenly'>

          {/* Left */ }
          <Grid2 size={{ xs: 5 }}>
            <Typography className='title'>{t(data.topItem.title)}</Typography>
            {
              data.topItem.description && data.topItem.description.map((item, index) => (
                <Typography key={index}><Trans i18nKey={item} components={{ strong: <strong /> }} /></Typography>
              ))
            }

            <Button disabled={model.isLoading.addAccount} variant="contained" fullWidth onClick={onClick} >
              <data.topItem.buttonIcon />
              {model.isLoading.addAccount ? (
                <CircularProgress size={15} sx={{ bgcolor: 'transparent', color: 'white' }} />
              ) : (
                t(data.topItem.buttonText)
              )}
            </Button>
          </Grid2>

          {/* Right */ }
          <Grid2 size={{ xs: 4 }}>
            <Box className="w-full video-bg">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen={true}
                title={generateUuid()}
                src={data.topItem.videoUrl}
                loading="lazy"
              />
            </Box>
          </Grid2>
        </Grid2>
      </PaperItem>

      <PaperItem className='flex-col gap-2 boxShadow' sx={{ width: '100%', p: 5 }} >
        {/* Top */ }
        <Grid2 size={{ xs: 12 }} sx={{ mb: 4 }} flexDirection='column' display={'flex'} alignItems='center' >
          <Typography className='title'>{t(data.bottomItem.title)}</Typography>
          <Typography>{t(data.bottomItem.description)}</Typography>
        </Grid2>

        {/* Bottom */ }
        { data.bottomItem.columns &&
            <Grid2 container spacing={10} >
              {data.bottomItem.columns.map((column, index) => (
                <Grid2 size={{ xs: column.size }} key={index}>
                  <img src={column.imageUrl} alt="Example" />
                  <Typography className='titleCard'>{t(column.title)}</Typography>
                  <Trans i18nKey={column.description} components={{ strong: <strong /> }} />
                </Grid2>
              ))
              }
            </Grid2>
        }

      </PaperItem>
    </Grid2>
  )
}